import './spinner.css';

export default function Spinner() {
  return (
    <div className="spinner-container">
      <span className="spinner"></span>
    </div>
  );
}
